<style>
.floating-menu-overlay {
  z-index: 99999 !important;
}

.floating-submenu-overlay {
  z-index: 100000 !important;
}
</style>

@if (!collapsed) {
  <!-- Menu normal -->
  <p-menu [model]="visibleItems" class="flex justify-center" styleClass="w-full md:w-70">
    <ng-template #item let-item>

      <!-- Garde-fou niveau 1 : PrimeNG passe TOUS les items au #item template,
           y compris ceux marqués `visible: false`. On filtre ici pour respecter
           la prop `visible` au niveau racine du menu (sections + items de 1er niveau). -->
      @if (item.visible || item.visible === undefined) {

      @if (item.items) {

        <a pRipple class="flex items-center p-menu-item-link"
           (click)="toggleSubmenu(item, $event)"
           [class.active]="item.expanded"
           [class.menu-item-active]="isActiveRoute(item)">
          <span class="w-[22px] d-block" [ngClass]="item.icon"></span>

          @if (!layoutServiceStates['layout-static-inactive']){
            <span class="ml-2 flex-1">{{ item.label|transloco }}</span>
          }

          @if (item.badge) {
            <p-badge class="ml-auto mr-2" [value]="item.badge" />
          }
          @if (item.shortcut) {
            <span class="ml-auto mr-2 border border-surface rounded bg-emphasis text-muted-color text-xs p-1">
              {{ item.shortcut }}
            </span>
          }
          @if (item.items) {
            <i class="pi ml-auto transition-transform duration-200"
               [class.pi-chevron-right]="!item.expanded"
               [class.pi-chevron-down]="item.expanded"></i>
          }
        </a>

      } @else {
  <!--           [routerLink]="item.routerLink ? item.routerLink : null"-->
        <a pRipple class="flex items-center p-menu-item-link"
          (click)="toggleSubmenu(item, $event)"
           [routerLinkActive]="item.routerLink ? ['menu-item-active'] : []"
           [routerLink]="item.routerLink"
           [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }">
          <span class="w-[22px] d-block" [ngClass]="item.icon"></span>

          @if (!layoutServiceStates['layout-static-inactive']){
            <span class="ml-2 flex-1">{{ item.label }}</span>
          }
          @if (item.badge) {
            <p-badge class="ml-auto mr-2" [value]="item.badge" />
            }
          @if (item.shortcut) {
            <span class="ml-auto mr-2 border border-surface rounded bg-emphasis text-muted-color text-xs p-1">
              {{ item.shortcut }}
            </span>
          }
        </a>
      }

      <!-- Sous-menu -->
      @if (item.items && item.expanded) {
        <!-- {{item|json}} -->
         @if (item.visible || item.visible === undefined) {
          <div class="submenu ml-4 mt-1 border-l-2 border-surface-200 pl-3"
              [@slideDown]
              (click)="$event.stopPropagation()">
            @for (subItem of item?.items; track subItem.label) {

              @if (subItem.visible || subItem.visible === undefined) {
                <div class="submenu-item">
      <!--                 [routerLink]="subItem.routerLink"-->
      <!--                 (click)="onSubItemClick($event)"-->
                  <a pRipple class="flex items-center p-2 hover:bg-surface-100 dark:hover:bg-surface-800 rounded cursor-pointer"
                    (click)="toggleSubmenu(subItem, $event, item)"
                    [routerLinkActive]="subItem.routerLink ? ['menu-item-active'] : []"
                    [routerLink]="subItem.routerLink"
                    [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }"
                  >
                    <span class="w-[22px] d-block text-sm" [ngClass]="subItem.icon"></span>

                    @if (!layoutServiceStates['layout-static-inactive']){
                      <span class="ml-2 flex-1">{{ subItem.label|transloco }}</span>
                    }

                    @if (subItem.badge) {
                      <p-badge class="ml-auto" [value]="subItem.badge" />
                    }

                    @if (subItem.items) {
                      <i class="pi ml-auto transition-transform duration-200"
                        [class.pi-chevron-right]="!subItem.expanded"
                        [class.pi-chevron-down]="subItem.expanded"></i>
                    }
                  </a>

                  <!-- Sous-sous-menu (3ème niveau) -->
                  @if (subItem.items && subItem.expanded) {
                    <div class="submenu ml-4 mt-1 border-l-2 border-surface-200 pl-3"
                        [@slideDown]
                        (click)="$event.stopPropagation()">
                      @for (subsubItem of subItem?.items; track subsubItem.label) {
                        @if (subsubItem.visible || subsubItem.visible === undefined) {
                          <div class="submenu-item">
                            <a pRipple class="flex items-center p-2 hover:bg-surface-100 dark:hover:bg-surface-800 rounded cursor-pointer"
                              (click)="toggleSubmenu(subsubItem, $event, subItem)"
                              [routerLinkActive]="subsubItem.routerLink ? ['menu-item-active'] : []"
                              [routerLink]="subsubItem.routerLink"
                              [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }"
                            >
                              <span class="w-[22px] d-block text-sm" [ngClass]="subsubItem.icon"></span>

                              @if (!layoutServiceStates['layout-static-inactive']){
                                <span class="ml-2 flex-1 text-sm">{{ subsubItem.label|transloco }}</span>
                              }

                              @if (subsubItem.badge) {
                                <p-badge class="ml-auto" [value]="subsubItem.badge" />
                              }

                              @if (subsubItem.items) {
                                <i class="pi ml-auto transition-transform duration-200"
                                  [class.pi-chevron-right]="!subsubItem.expanded"
                                  [class.pi-chevron-down]="subsubItem.expanded"></i>
                              }
                            </a>

                            <!-- Sous-sous-sous-menu (4ème niveau) -->
                            @if (subsubItem.items && subsubItem.expanded) {
                              <div class="submenu ml-4 mt-1 border-l-2 border-surface-300 pl-3"
                                  [@slideDown]
                                  (click)="$event.stopPropagation()">
                                @for (subsubsubItem of subsubItem?.items; track subsubsubItem.label) {
                                  @if (subsubsubItem.visible || subsubsubItem.visible === undefined) {
                                    <div class="submenu-item">
                                      <a pRipple class="flex items-center p-2 hover:bg-surface-100 dark:hover:bg-surface-800 rounded cursor-pointer text-sm"
                                        (click)="toggleSubmenu(subsubsubItem, $event, subsubItem)"
                                        [routerLinkActive]="subsubsubItem.routerLink ? ['menu-item-active'] : []"
                                        [routerLink]="subsubsubItem.routerLink"
                                        [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }"
                                      >
                                        <span class="w-[22px] d-block text-xs" [ngClass]="subsubsubItem.icon" ></span>

                                        @if (!layoutServiceStates['layout-static-inactive']){
                                          <span class="ml-2 flex-1 text-xs">{{ subsubsubItem.label|transloco }}</span>
                                        }

                                        @if (subsubsubItem.badge) {
                                          <p-badge class="ml-auto text-xs" [value]="subsubsubItem.badge" />
                                        }
                                      </a>
                                    </div>
                                  }
                                }
                              </div>
                            }
                          </div>
                        }
                      }
                    </div>
                  }
                </div>
              }
            }
          </div>
        }
      }

      } <!-- /@if visible niveau 1 -->
    </ng-template>

  </p-menu>
} @else {

  <!-- Menu collapsed -->
  <div class="space-y-1 align-items-center flex flex-col justify-center">
    @for (section of visibleItems; track section.label) {
      <!-- Garde-fou niveau 1 : ne pas rendre les icônes d'une section masquée -->
      @if (section.visible || section.visible === undefined) {
      @if (section.items) {
        @for (item of section.items; track item.label) {
          @if (item.visible || item.visible === undefined) {
            <div
              #menuItem
              [pTooltip]="(!item.items && item.label) ? item.label : null"
              tooltipPosition="top"
              class="flex h-12 w-12 items-center justify-center rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800"
              (mouseenter)="onMenuItemHover(item, menuItem, true)"
              (mouseleave)="onMenuItemHover(item, menuItem, false)"
              (click)="handleCollapsedItemClick(item)"
            >
              <i [class]="item.icon" class="text-xl text-gray-600 dark:text-gray-300"></i>
            </div>
          }
        }
      }
      } <!-- /@if section.visible -->
    }
  </div>
}

<!-- Template pour le menu flottant -->
<ng-template #floatingMenuTemplate>
  <div class="absolute -left-2 top-0 w-2 h-full"></div>
  <div class="min-w-[200px] rounded-lg bg-white shadow-xl border border-gray-200 dark:bg-gray-800 dark:border-gray-700"
       (mouseenter)="onFloatingMenuHover(true)"
       (mouseleave)="onFloatingMenuHover(false)">

    <!-- En-tête avec le nom du parent -->
    @if (hoveredItem?.label) {
      <div class="px-4 py-2 text-xs font-semibold text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-gray-700/50 rounded-t-lg">
        {{ hoveredItem.label }}
      </div>
    }

    @if (hoveredItem?.items) {
      @for (subItem of hoveredItem.items; track subItem.label) {
        @if (subItem.visible || subItem.visible === undefined) {
          <div class="relative group/submenu">
            <a
              #subMenuItem
              [routerLink]="subItem.routerLink"
              (click)="onSubItemClick(subItem)"
              (mouseenter)="onSubMenuItemHover(subItem, subMenuItem, true)"
              (mouseleave)="onSubMenuItemHover(subItem, subMenuItem, false)"
              class="flex items-center px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700"
              [class.cursor-default]="subItem.items"
            >
              <i [class]="subItem.icon" class="mr-3"></i>
              {{ subItem.label }}
              @if (subItem.items) {
                <i class="pi pi-chevron-right ml-auto text-xs"></i>
              }
            </a>
          </div>
        }
      }
    }
  </div>
</ng-template>

<!-- Template pour le sous-sous-menu -->
<ng-template #subFloatingMenuTemplate>
  <div class="absolute -left-4 top-0 w-4 h-full"></div>

  <div class="min-w-[200px] rounded-lg bg-white shadow-xl border border-gray-200 dark:bg-gray-800 dark:border-gray-700"
       (mouseenter)="onSubFloatingMenuHover(true)"
       (mouseleave)="onSubFloatingMenuHover(false)">

    <!-- En-tête avec le nom du sous-parent -->
    @if (hoveredSubItem?.label) {
      <div class="px-4 py-2 text-xs font-semibold text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-gray-700/50 rounded-t-lg">
        {{ hoveredSubItem.label }}
      </div>
    }

    @if (hoveredSubItem?.items) {
      @for (subSubItem of hoveredSubItem.items; track subSubItem.label) {
        @if (subSubItem.visible || subSubItem.visible === undefined) {
          <a
            [routerLink]="subSubItem.routerLink"
            (click)="hideAllFloatingMenus(); clicked.emit()"
            class="flex items-center px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700"
          >
            <i [class]="subSubItem.icon" class="mr-3"></i>
            {{ subSubItem.label }}
          </a>
        }
      }
    }
  </div>
</ng-template>
